// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16hVJ","questions":"styles_questions__1B6m1","footer":"styles_footer__1ckGS"};